﻿const axios = require('axios');
import { required, email } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';
import datatable from './components/dataTable.vue';
import Tab from './components/tabs/tab.vue';
import Tabs from './components/tabs/tabs.vue';

const userManagementApp = {
    setup: () => ({ v$: useVuelidate() }),
    components: {
        datatable,
        Tab,
        Tabs,
    },
    data() {
        return {
            loading: false,
            api: '',
            roles: [],
            method: 'post',
            header: null,
            menu: null,
            userStep: 1,
            user: {
                Email: '',
                Username: '',
                Firstname: '',
                Insertion: '',
                Lastname: '',
                UserRoleID: '',
            },
            userData: {
                typeAlias: ''
            }
        }
    },
    validations() {
        return {
            user: {
                Email: { required, email },
                Username: { required },
                Firstname: { required },
                Lastname: { required },
                UserRoleID: { required },
            }
        }
    },
    async created() {
        await this.getUserRoles();
    },
    methods: {
        async getUserRoles() {
            const response = await axios.get('/api/organisation/memberroles');
            this.roles = response.data;
        },
        scrollTo($elm) {
            window.scrollTo({ top: $elm.getBoundingClientRect().top + window.pageYOffset - this.header.offsetHeight - this.menu.offsetHeight - 20, behavior: 'smooth' });
        },
        async submitUserStep() {
            if (this.userStep == 1) {
                let valid1 = await this.v$.user.$validate();
                if (!valid1) {
                    this.scrollTo(document.querySelector('.form-error').closest('.field'));
                } else {
                    this.loading = true;
                    const response = await this.fetchData(this.user, this.api, this.method);
                    if (response.status === 200) {
                        this.loading = false;
                        this.userData = response.data;
                        if (this.userData.typeAlias === 'Success') {
                            this.userStep = 2;
                            this.$nextTick(() => {
                                this.scrollTo(this.$refs.step2top);
                            });
                        } else {
                            this.$nextTick(() => {
                                this.scrollTo(document.querySelector('.form-error').closest('.field'));
                            });
                        }
                    }
                }
            } else if (this.userStep == 2) {
                this.user = {
                    Email: '',
                    Username: '',
                    Firstname: '',
                    Insertion: '',
                    Lastname: '',
                    UserRoleID: '',
                }
                location.reload();
            }
        },
        async fetchData(formData, apiUrl, methodType) {
            try {
                const response = await axios({
                    method: methodType,
                    url: apiUrl,
                    data: formData,
                    headers: { 'Content-Type': 'application/json' },
                })
                return response;
            } catch (error) {
                console.log(error);
            }
        },
    },
    mounted() {
        this.header = document.getElementById('navbar');
        this.menu = document.getElementById('menu');
        if (this.$el.dataset.saveuser) this.api = this.$el.dataset.saveuser;
        if (this.$el.dataset.method) this.method = this.$el.dataset.method;
        this.$refs.userList.getData();
    }
}

export default userManagementApp;
